import * as validators from './formValidators';
import { validateDynamicForm } from './dynamicFormValidator';
import { filterDynamicFieldsMap } from '../components/common/DynamicFields';

export const validatePaymentForm = (data, props) => {
    let errors = {};
    let fee = data['Fee'];

    let error = validators.validateFloat(fee, 'Fee');
    errors = { ...errors, ...error };
    if (props.fieldsMap) {
        error = validateDynamicForm(data, filterDynamicFieldsMap(props.fieldsMap));
        errors = { ...errors, ...error };
    }

    return errors;
};
